<template>
  <v-app>
    <Karkas />
  </v-app>
</template>

<script>
import Karkas from "@/components/Karkas";
export default {
  components: {
    Karkas,
  },
};
</script>

<style lang="sass">

.fade-enter-active, .fade-leave-active
  transition: all .5s linear

.fade-enter, .fade-leave-to
  opacity: 0
.fade_late-enter-active, .fade_late-leave-active
  transition: all 1s linear

.fade_late-enter, .fade_late-leave-to
  opacity: 0

.onHover
  cursor: pointer !important
.noHover
  cursor: normal !important
.onHoverDecorate
  text-decoration: none
  &:hover
    text-decoration: underline
.onHoverColor
  transition: all 0.3s ease-in-out
  &:hover
    background-color: rgba(gray, 0.4)
    border-radius: 5px
.alerts
  .v-alert__wrapper
    .v-alert__content
      display: grid
      grid-template-columns: 1fr 90px
      grid-template-areas: ". button"
      p
        margin: 0
        padding: 0
      .v-btn
        background-color: white
        grid-area: button
        justify-self: end
        color: black
.v-rating
  padding: 0 10px
  button
    padding: 7px 0px !important
.innEditOff
  position: relative
  z-index: 1
  &::after
    content: ''
    position: absolute
    top: 0px
    left: 0px
    right: 0px
    bottom: 0px
    width: 96%
    height: 100%
.rating__off
  position: relative
  z-index: 1
  .rating_star
    z-index: -1
  &::after
    content: ''
    position: absolute
    top: 0px
    left: 0px
    right: 0px
    bottom: 0px
    width: 100%
    height: 100%
.rating__avarege
  width: 100%
  cursor: normal
  overflow: hidden


</style>
